import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC, Ref } from 'react';
import css from './style.module.scss';
interface Props {
  className?: string;
  ref?: Ref<HTMLDivElement>;
}
const RevealCurtain: FC<Props> = t0 => {
  const $ = _c(5);
  const {
    className,
    ref
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx(css.root, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== ref || $[3] !== t1) {
    t2 = <div ref={ref} aria-hidden={true} className={t1} />;
    $[2] = ref;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default RevealCurtain;